module.exports = __webpack_public_path__ + "img/important.97b20a4c.svg";